<template  >
<div :class="this.$store.state.lang">  

<Audio
       loop
       id="bg_audio"
       autoplay
        
      >
       <source src="@/assets/video/tiffany.mp3"  type="audio/mpeg" />
</audio> 


  <DiyModal msg=""  />

  <DiyModalDeclare msg=""  />
<!--   <nav v-show="this.$store.state.isTopShow"> 
    <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
  </nav>  -->

  <div class="music_bg">


    <ul>

    <li>
    <button @click="soundSwich" class="btn btn-plain btn-icon btn-icon--audio header-btn-audio nav-link header-btn-audio--on"
     type="button">
     <i class="icon-sound img-on" v-show="this.$store.state.soundOn"></i>
     <i class="icon-sound-muted img-off"  v-show="!this.$store.state.soundOn"></i>
    </button>
    </li>

    <li @click="langChange('cn')">
      繁
    </li>

    <li @click="langChange('sc')">
      简
    </li>

    </ul>


  </div>

  
  
    <SectionPage    />




  <loading 
        loader="bars"
        v-model:active="
    this.$store.state.isLoading"                             
     :is-full-page="true"/>
    

    

</div>
</template>

<script>


import Section from './components/SectionPage.vue'
import DiyModal from './components/DiyModal.vue'
import DiyModalDeclare from './components/DiyModalDeclare.vue'
import SectionPage from './components/SectionPage.vue'



import Loading from 'vue-loading-overlay';

 
export default {
  name: 'App',

  
  components: {
    Section,
    DiyModal,
    SectionPage,
    Loading,
    DiyModalDeclare
}
  ,data () {
      return {
      soundOn:true 
        
      }
      }
    

,mounted:function(){
    
//console.log( this.$store.state.soundOn)


/* 
    document.querySelector('body').addEventListener("click", function(){
      
  
        var promise = document.querySelector('audio').play();

          if (promise !== undefined) {
          promise.then(_ => {
            // Autoplay started!
            console.log('Autoplay started!')
          }).catch(error => {
            // Autoplay was prevented.
            // Show a "Play" button so that user can start playback.
            console.log(error)
          });
          }

    }); */



    //console.log('mounted')
      //var promise =  document.getElementById('bg_audio')
  


   
  },methods:{

    langChange(_temp){

    console.log(_temp)  

    var cur = this 

    this.$store.state.lang = _temp


    if(_temp==='cn'){
    this.$store.state.videoSource = require('@/assets/video/index.mp4')
    }else{
    this.$store.state.videoSource =  require('@/assets/video/Chinese.mp4')
    }


    
    var oMedia = document.getElementById("myVideo");

    oMedia.load()
    
    
    
    
      

      },

    soundSwich(){
     
      //this.soundOn = !this.soundOn
      this.$store.state.soundOn = !this.$store.state.soundOn
      const music =   document.querySelector('audio')
  
      if(this.$store.state.soundOn === true){
          music.play()
          
      }else{
          music.pause()
         
      } 
      document.querySelector('video').pause();
    

    }
  

  }
  
}
</script>

<style>


@font-face {
    font-family: CormorantGaramond;
    src: url("@/assets/font/CormorantGaramond-Regular.ttf") ;
}


@font-face {
    font-family: NotoSansHK;
    src: url("@/assets/font/NotoSansHK-Thin.otf") ;
}


@font-face {
    font-family: Noto_Sans_SC;
    src: url("@/assets/font/NotoSansSC-Thin.otf") ;
}



@font-face {
    font-family: "icons";
    src:url(@/assets/font/icons.woff) format("woff")
}

body{
  margin:0;
  
}
body p ,.content,.title{
  color:#846C32
} 


.music_bg>div{
  float: left;

}

.music_bg{
  position: absolute;
  top:1%;
  right: 1%;
  z-index: 99999999999999;
    font-size: 16px;
    font-weight: bolder;
    color: #846C32;
}
.music_bg i{
  vertical-align: -webkit-baseline-middle;
   color: #846C32;

}
.music_bg ul{
  display: flex;
  align-items: center;
}
.music_bg li{
  cursor: pointer;
  list-style:none;
  float: left; 
  padding-right: 5px;
}

.music_bg button{
  border: 0;
  background: transparent;
  font-size: 19px;
}

i[class^="icon-"]:before, i[class*=" icon-"]:before {
    font-family: icons !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.icon-sound:before {
    content: "\f10f";
}
.header-btn-audio--muted .img-off {
    display: flex;
}
.icon-sound-muted:before {
    content: "\f10e";
}

.top_title{
color: #846C32;
text-align: center;
width: 100%;
}
.top_container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
   
    margin: 0 auto;
}


.imagebook .title,.localMap .title{
  width: 100%;
    font-size: 3vw;
    margin-top: 5%;
}

.imagebook  .content_area{

  font-size: 1.2vw;
}

.imagebook  .section_container{
     margin-top: 0%;
}
/* 
 .section.active .image_list{
  width: 50%;
  float: left;
  margin:  0 auto;
   animation-delay: 2s;
  	animation-name: top_en_fadein;
    position: relative;
}  */

#section1{
  width: 100%;
  height: 100%;


  /* #background-size:100%  100%; */
  background-size:cover;
  background-repeat:no-repeat ;
  background-image: url('@/assets/img/TiffanyHousePhotos-4_3-min.jpg'); 
}

.section .image_list{
  width: 80%;
  float: left;
  margin:  0 auto;
   animation-delay: 2s;
  	 animation-name: top_en_fadein; 
    
    position: relative;
}






.section.active.imagebook .title,.section.active .localMap .title{
   	animation-duration: 1s;
  	animation-name: top_en_fadein;
}



.page-down-arrow {
   
    -webkit-animation: arrow-float-vt 0.8s infinite;
    animation: arrow-float-vt 0.8s infinite;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    will-change: transform;
}

.map  .container{
margin-top: 0%;
background-color: #a38a7a;
height: 100%;
display: flex;
}

.map  .container>div:nth-child(1){
 background: url('@/assets/img/local_map.png') no-repeat;
position: relative;
    width: 50%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  
    background-size: cover;
    background-position: center;

}
.map  .container .leftSide.building {
 background: url('@/assets/img/shutterstock.jpg') no-repeat;
position: relative;
    width: 50%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  
    background-size: cover;
    background-position: center;

}



.section.declare  .container .leftSide {
 background: url('@/assets/img/TiffanyHousePhotos7.jpg') no-repeat;
position: relative;
    width: 50%;
    /* height: 100%; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  
    background-size: contain;
    background-position: center;

}

.section.declare  .container .rightSide{
 width: 50%;
    height: 100%;
      
 

}

.section.declare .container{

  margin-top: 0%;
   
  
    display: flex;
}




.map .leftSide img{
 
  height: 100vh;
  
}
.map .rightSide .table{
    width: 80%;
}

.active.map .rightSide .title{
        -moz-animation-duration: 1s;
            -webkit-animation-duration: 1s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
}


.active.map .rightSide .dclare{
  
         -moz-animation-duration: 1s;
            -webkit-animation-duration: 1s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
}
.active.map .rightSide .table{
    width: 80%;
    /* transition: all .4s ease-in-out; */
    
    padding: 0;

         -moz-animation-duration: 1s;
            -webkit-animation-duration: 1s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
    	
   
} 

      @-moz-keyframes slidein {
            from {
              /*  margin-left:100%; */
               margin-left:50%;
              
            }

            to {
               /* margin-left:0%; */
               margin-left:0%;
            }
         } 

           @-webkit-keyframes slidein {
              from {
              /*  margin-left:100%; */
               margin-left:50%;
              
            }

            to {
               /* margin-left:0%; */
               margin-left:0%;
            }
          
         }
     /*     @-webkit-keyframes slidein {
            to {
               margin-left:100%;
               width:100%
            }
            from {
               margin-left:0%;
               width:100%;
            }
         } */


.redefine.active{
  
   z-index: 9998;
   
  
}

.redefine.active  .masker{

width:100%;
height: 100%;
  z-index: 9998;
     -moz-animation: changeMask 4s;
            -webkit-animation: changeMask 4s;
         background:  rgba(0, 0, 0, 0.5)


}



@keyframes changeMask{
100%{
background:  rgba(0, 0, 0, 0.5)

}
0%{
background:   transparent 

}
}

@-webkit-@keyframes changeMask{
100%{
background:  rgba(0, 0, 0, 0.5)

}
0%{
background:   transparent 

}
}


.redefine.active .top_title{
  z-index: 9999;
  filter: brightness(100%);
   position:absolute;
}



@keyframes mymove
{
   0%{
    
	 filter: brightness(100%);
  }
 100%{
     filter: brightness(50%);
	  
     
  }
}

@-webkit-@keyframes mymove
{
   0%{
	 filter: brightness(100%);
  }
 100%{
     filter: brightness(50%);	  
  }
}


@-webkit-keyframes fadeOutLeft {
  0% {
    
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  100% {
    
    -webkit-transform: translateX(120px);
    transform: translateX(120px);
  }
}

@keyframes fadeOutLeft {
  0% {
 
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }

  100% {
    
    -webkit-transform: translateX(120px);
    -ms-transform: translateX(120px);
    transform: translateX(120px);
  }
}



.map   img{
    width: 24px;
    height: 24px;
}
.map .rightSide .table .title_top{
   border-bottom: 1px solid #fff;
}
.map .rightSide.second .table .title_top{
   border-bottom: 1px solid #846C32;
}


.map .rightSide.second table{
color:#846C32;
}





 .map .rightSide table td
 {
    padding: 4px 0;
    font-size: 16px;
}


.map .rightSide table
{
color: #fff;
text-align: left;
    margin: 0 auto;
    width: 100%;
    height: 80%;
       border-collapse: collapse;border-spacing: 0;

}


.map .rightSide .title
{
  width: 100%;
  display: flex;

  justify-content: center;
    align-items: center;
  
    font-size: 4vh;

}

.map .rightSide .title p
{
  color:#fff;
}


.map  .container>div:nth-child(2){


position: relative;
    width: 50%;
    height: 100%;
    
    /* transition: all .4s ease; */
    padding: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    animation-name: fadeInLeft;
}

.map   .second{
justify-content: center;
}


.map  .dclare{
  background-color: #a38a7a;
 
}
.map .dclare p{
 color: #fff;
 font-size: 14px;
}

.map .second .dclare{ background-color: white;}

.map .second  .dclare p{
 color: #846C32;
 font-size: 14px;
 background: white;
}


.section.active.imagebook   .section_container>div:nth-child(1){
  	animation-duration: 1.5s;
  	animation-name: top_en_fadein;
}
.section.active.imagebook   .section_container>div:nth-child(2){
  	animation-duration: 1.8s;
  	animation-name: top_en_fadein;
}
.section.active.imagebook   .section_container>div:nth-child(3){
  	animation-duration: 2.2s;
  	animation-name: top_en_fadein;
}







.image_list>div{
width: 22.5%;
  float: left;
  padding: 1%;
   
    position: relative;
} 

.image_list>div img{
object-fit: cover;
  
}

.section.active .image_list>div:nth-child(1) {
 	animation-duration: 1s;
  
    animation-name: top_en_fadein;
   
}

.section.active .image_list>div:nth-child(2) {
  animation-duration: 2s;
  	    animation-name: top_en_fadein;
}

.section.active .image_list>div:nth-child(3) {
  animation-duration: 3s;
  	  animation-name: top_en_fadein;
}

.section.active .image_list>div:nth-child(4) {
 animation-duration: 4s;
  	  animation-name: top_en_fadein;
}




.top_logo {
    width: 23vw;
    max-width: 380px;
    
    margin-bottom: 2vh;
}
.top_title .top_title_en {
   
    font-weight: 200;
  
    font-size: 3vw;
    line-height: 3vw;
    text-transform: uppercase;
    text-align: center;
    margin: 0px auto 15px;
     color: #fff;
}

.top_title .top_title_tc {
    
    font-weight: 200;
  
    font-size: 3vw;
    line-height: 5vw;
    letter-spacing: 0.3px;
    text-align: center;
    color: #fff;
}


.section.active .top_logo_active {
	animation-name: logoAnime;
  	animation-duration: 2s;
}
.section.active .top_title_en_active {
	animation-name: top_en_fadein;
	animation-duration: 2.5s;
}
.section.active  .top_title_tc_active {
	animation-name: top_tc_fadein;
	animation-duration: 3s;
}

@keyframes logoAnime {
  0% {
    transform: translateY(100px);
	opacity: 0;
  }
  100% {
    transform: translateY(0px);
	  opacity: 1;
  }
}
@keyframes top_en_fadein {
  	0% {
		transform: translateY(30px);
		opacity: 0;
	}
	50% {
		transform: translateY(30px);
		opacity: 0;
	}
  100% {
    transform: translateY(0px);
	opacity: 1;
  }
}
@keyframes top_tc_fadein {
  	0% {
		transform: translateY(30px);
		opacity: 0;
	}
	70% {
		transform: translateY(30px);
		opacity: 0;
	}
  100% {
    transform: translateY(0px);
	opacity: 1;
  }
}

@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } }
@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } }
@keyframes Gradient {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } 
}


@-webkit-keyframes arrow-float-vt {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-10px);
    -ms-transform: translateY(-10px);
    transform: translateY(-10px); }
  100% {
    opacity: 1;
    -webkit-transform: translateY(10px);
    -ms-transform: translateY(10px);
    transform: translateY(10px); } }
@keyframes arrow-float-vt {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-10px);
    -ms-transform: translateY(-10px);
    transform: translateY(-10px); }
  100% {
    opacity: 1;
    -webkit-transform: translateY(10px);
    -ms-transform: translateY(10px);
    transform: translateY(10px); } }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}

.vld-overlay.is-full-page{
  z-index: 9999999999999999;
}


#section8 .content{
color:black;
width: 90%;
margin: 0 auto;
}

#section8  .chinaStart{
  width: 100px;
  height: 100px;
}


/* Fade In Left */

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translateX(-20px);
    -ms-transform: translateX(-20px);
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
}

.map.active  .rightSide {
    animation-name: fadeInLeft;
    animation-duration: 2.3s;
}

.four_building{

background:#edecec


}

@media screen and (max-width: 890px), screen and (max-height: 400px){




.imagebook .title{
  margin-top: 100px;
}


.section.declare .container .rightSide{
  width: 100%;
}

#section8 .container .rightSide .chinaStart{
  width: 60px;
  height:60px;
}

.section.map .container{
  height: unset;
}

  .section.map .container>div:nth-child(2){

    width: 100%;
  }

  .section.map .rightSide table td{
    font-size: 14px;
  }
.top_title .top_title_tc {
    font-weight: bolder;
    font-size: 8vw;
    line-height: 3vw;
    letter-spacing: 0.3px;
    text-align: center;
}


.top_title .top_title_en {
    font-weight: bolder;
    font-size: 5vw;
    line-height: 8vw;
    text-transform: uppercase;
    text-align: center;
    margin: 0px auto 15px;
}

.top_logo{
  width: auto;
}
.image_list{
  width: 90%;
  float: left;
  margin:  0 auto;
}

.image_list>div{
width: 45%;
  float: left;
  padding: 2.333%;
}

nav .logo img{
 height: 50px;
 height: 50px;
 
}


  .section.declare .container .rightSide{
  /*   width: 100%; */
         -moz-animation-duration: 1s;
            -webkit-animation-duration: 1s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
}


}



  .active.section.declare .rightSide .title{
  
           -moz-animation-duration: 2s;
            -webkit-animation-duration: 2s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
}


  .active.section.declare .rightSide .content{
  
           -moz-animation-duration: 2s;
            -webkit-animation-duration: 2s;
            -moz-animation-name: slidein;
            -webkit-animation-name: slidein;
}

@media   (min-width:1024px){





.section>div:not(#section1>div,
.videoArea,.section.map>div,.logo,#section8>div,.contact_us>div
,.imagebook>div

){
  
margin-top: 60px;

}
.four_building{



}


nav .logo img{
 height: 110px;
 height: 110px;
  
 /*  padding-top:110px; */
}




}
.mask{
    position: absolute;
   width: 100vw;
   height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99998
}
#fp-nav.fp-right{
  display: none;
}

#app  .cn{

font-family: NotoSansHK;
}

#app  .sc{

font-family: Noto_Sans_SC;
}

#app {
 
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  --swiper-theme-color:unset;
 
}


.swiper-button-prev,.swiper-button-next{
color:gray
}


nav {
    /* position: fixed; */
    position:absolute;
    top: 5%;
    right: 0;
    left: 0;
    z-index: 1030;
  height: 60px;
  width: 100%;
  background: transparent;
}


nav{
  width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   
}





#section0{
background-image: url('@/assets/img/section0_bg.jpg');
}

/* .map>div{
  margin-top: 30px;
} */
</style>
